import React, { useState } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../styles/About.css";
import abouthealthcare from "../assets/galleryimg1.avif"
/* =========================================================
   UHCS CONTENT
========================================================= */

const focusAreas = [
    ["01", "Quality improvement in healthcare services", "fa-file-shield"],
    ["02", "Skill development and reskilling of healthcare professionals", "fa-users-gear"],
    ["03", "International certification and education collaboration", "fa-certificate"],
    ["04", "Hospital service upgradation", "fa-hospital"],
    ["05", "JCI and NABH-oriented quality improvement", "fa-clipboard-check"],
    ["06", "Employment and placement support", "fa-briefcase"],
    ["07", "Healthcare awareness and preventive healthcare", "fa-heart-pulse"],
    ["08", "Social security support for paramedical professionals", "fa-user-shield"],
    ["09", "Healthcare financial and reimbursement support", "fa-file-invoice-dollar"],
    ["10", "Universal Health Coverage initiatives", "fa-earth-americas"],
];

const visionPoints = [
    "Every individual can access quality healthcare at an affordable cost.",
    "Healthcare professionals receive continuous skill development and career opportunities.",
    "Hospitals continuously improve their quality and patient-care standards.",
    "Indian healthcare institutions become aligned with recognized national and international standards.",
    "Paramedical professionals receive professional, social, and career support.",
    "Preventive healthcare and community health awareness become accessible to everyone.",
    "Indian healthcare professionals become globally employable and internationally certified.",
];

const missions = [
    ["01", "Develop and reskill healthcare and paramedical professionals."],
    ["02", "Create opportunities for employment and career advancement."],
    ["03", "Promote international certification and education collaborations."],
    ["04", "Support hospitals in improving services according to JCI and NABH-oriented quality standards."],
    ["05", "Promote affordable and accessible healthcare."],
    ["06", "Support healthcare institutions in improving operational and service quality."],
    ["07", "Promote preventive healthcare and community health awareness."],
    ["08", "Support social security initiatives for paramedical professionals."],
    ["09", "Assist private hospitals with healthcare reimbursement and payment-recovery challenges."],
    ["10", "Build a large, skilled, future-ready healthcare workforce in India."],
];

const objectives = [
    [
        "01",
        "Healthcare Quality Improvement",
        "Support healthcare institutions in improving service quality, patient safety, operational efficiency, and healthcare standards.",
    ],
    [
        "02",
        "Skill Development & Reskilling",
        "Provide structured training, skill development, and reskilling opportunities for paramedical and healthcare professionals.",
    ],
    [
        "03",
        "Employment & Placement",
        "Build pathways connecting trained healthcare professionals with suitable employment opportunities in India and abroad.",
    ],
    [
        "04",
        "International Certification",
        "Facilitate access to international certification, professional education, and global healthcare learning opportunities.",
    ],
    [
        "05",
        "Hospital Upgradation",
        "Support hospitals in improving their infrastructure, systems, processes, documentation, quality management, and patient-care services.",
    ],
    [
        "06",
        "Standards & Accreditation Support",
        "Promote awareness and implementation of quality practices aligned with JCI, NABH, WHO and UHC-oriented frameworks, as applicable.",
    ],
    [
        "07",
        "Community Healthcare",
        "Promote preventive healthcare, health awareness, basic health education, and healthy-lifestyle practices within communities.",
    ],
    [
        "08",
        "Professional Social Security",
        "Work toward developing support mechanisms and social-security initiatives for paramedical and healthcare professionals.",
    ],
    [
        "09",
        "Healthcare Financial Support",
        "Provide guidance and action-oriented support to eligible private hospitals regarding challenges related to insurance claims and government healthcare-scheme payments.",
    ],
    [
        "10",
        "Universal Health Coverage",
        "Contribute to the broader objective of making quality healthcare more accessible, affordable, equitable, and sustainable.",
    ],
];

const programs = [
    [
        "A",
        "Healthcare Professional Skill Development Program",
        "UHCS develops and supports skill-development initiatives for paramedical professionals, allied healthcare professionals, hospital support staff, healthcare technicians, healthcare assistants, and emerging healthcare professionals.",
        [
            "Paramedical professionals",
            "Allied healthcare professionals",
            "Hospital support staff",
            "Healthcare technicians",
            "Healthcare assistants",
            "Emerging healthcare professionals ",
        ],
        "fa-user-doctor",
    ],
    [
        "B",
        "International Certification & Education Program",
        "UHCS promotes international exposure and professional development through education, certification, academic collaboration, global healthcare learning, and career opportunities.",
        [
            "International certification pathways",
            "Professional education",
            "Continuing education",
            "International academic collaboration",
            "Global healthcare learning",
            "Career opportunities abroad",
            "International placement support",
        ],
        "fa-globe",
    ],
    [
        "C",
        "Hospital Quality Improvement Program",
        "UHCS supports hospitals in strengthening quality systems, patient-care processes, documentation, staff competency, patient safety, service efficiency, and accreditation preparedness.",
        [
            "Patient-care processes",
            "Quality management systems",
            "Documentation",
            "Hospital workflows",
            "Staff competency",
            "Patient safety practices",
            "Service efficiency",
            "Quality monitoring",
            "Accreditation preparedness",
        ],
        "fa-hospital",
    ],
    [
        "D",
        "Healthcare Support & UHC Program",
        "UHCS works toward improving access to healthcare through Universal Health Coverage awareness, affordable healthcare support, education, preventive healthcare, and community outreach.",
        [
            "Universal Health Coverage awareness",
            "Healthcare access initiatives",
            "Affordable healthcare support",
            "Healthcare education",
            "Preventive healthcare programs",
            "Community outreach",
        ],
        "fa-heart-pulse",
    ],
    [
        "E",
        "Online Education & Surgical Assistance Support",
        "UHCS promotes technology-enabled healthcare education and professional support through digital learning, knowledge sharing, surgery-related educational assistance, and continuing education.",
        [
            "Online healthcare education",
            "Digital learning programs",
            "Professional knowledge sharing",
            "Surgery-related educational assistance",
            "Remote learning",
            "Continuing education",
        ],
        "fa-laptop-medical",
        "Programs and services are subject to applicable professional, legal, and regulatory requirements.",
    ],
    [
        "F",
        "Paramedical Social Security Program",
        "UHCS aims to develop support initiatives for paramedical professionals covering career, professional development, employment, education, welfare, and social-security awareness.",
        [
            "Career support",
            "Professional development",
            "Employment assistance",
            "Continuing education",
            "Welfare initiatives",
            "Social-security awareness",
        ],
        "fa-shield-heart",
    ],
    [
        "G",
        "Hospital Insurance & Government Scheme Support",
        "UHCS provides structured guidance and support to eligible private hospitals facing challenges related to insurance claims and government healthcare-scheme payments.",
        [
            "Insurance claim processing",
            "Claim documentation",
            "Payment delays",
            "Government healthcare-scheme reimbursement",
            "Payment-recovery processes",
            "Process improvement",
        ],
        "fa-file-invoice-dollar",
        "UHCS can develop guidelines, action plans, documentation support, and process-improvement frameworks for hospitals.",
    ],
    [
        "H",
        "Community Healthcare Awareness Program",
        "UHCS works to promote healthcare awareness among communities through preventive healthcare education, healthy-lifestyle awareness, disease-prevention education, healthcare literacy, and community programs.",
        [
            "Preventive healthcare education",
            "Basic health awareness",
            "Healthy lifestyle awareness",
            "Disease-prevention education",
            "Community healthcare camps",
            "Healthcare literacy",
            "Affordable healthcare awareness",
        ],
        "fa-people-group",
    ],
];

const workforceSteps = [
    [
        "01",
        "Mobilize",
        "Identify students, unemployed professionals, existing healthcare workers, and individuals seeking healthcare careers.",
        "fa-magnifying-glass",
    ],
    [
        "02",
        "Train",
        "Provide industry-relevant theoretical and practical skill development.",
        "fa-chalkboard-user",
    ],
    [
        "03",
        "Reskill",
        "Upgrade existing healthcare professionals according to changing technologies, procedures, and industry requirements.",
        "fa-arrows-rotate",
    ],
    [
        "04",
        "Assess",
        "Evaluate professional competency through appropriate assessment mechanisms.",
        "fa-clipboard-check",
    ],
    [
        "05",
        "Certify",
        "Facilitate appropriate national/international certification pathways wherever applicable.",
        "fa-certificate",
    ],
    [
        "06",
        "Place",
        "Connect qualified professionals with employment opportunities.",
        "fa-briefcase",
    ],
    [
        "07",
        "International Opportunities",
        "Create pathways for eligible professionals seeking international education and employment opportunities.",
        "fa-plane-departure",
    ],
    [
        "08",
        "Continuous Learning",
        "Establish continuing education and professional development programs.",
        "fa-book-open-reader",
    ],
];

const targetImpactAreas = [
    "Paramedical workforce",
    "Allied healthcare",
    "Hospital technical staff",
    "Healthcare support professionals",
    "Medical technology professionals",
    "Healthcare administration",
    "Digital healthcare",
    "Emerging healthcare technologies",
];

const whyChooseUs = [
    [
        "fa-network-wired",
        "Integrated Healthcare Ecosystem",
        "UHCS brings together healthcare professionals, hospitals, education, quality improvement, certification, employment, and community healthcare.",
    ],
    [
        "fa-chart-line",
        "Quality-Focused Approach",
        "Our programs are designed with a strong focus on healthcare quality, patient safety, professional competency, and continuous improvement.",
    ],
    [
        "fa-globe",
        "National & International Orientation",
        "UHCS promotes exposure to internationally recognized healthcare practices, education, certification, and career opportunities.",
    ],
    [
        "fa-user-graduate",
        "Professional Skill Development",
        "We focus on practical, industry-relevant training and continuous professional development.",
    ],
    [
        "fa-hospital",
        "Hospital-Centric Solutions",
        "UHCS supports hospitals not only in quality improvement but also in operational and reimbursement-related challenges.",
    ],
    [
        "fa-hand-holding-dollar",
        "Affordable Healthcare Focus",
        "We work toward improving healthcare accessibility and awareness while keeping affordability and inclusiveness at the center.",
    ],
    [
        "fa-laptop",
        "Technology-Enabled Learning",
        "Digital platforms and online education can help make professional learning more accessible across geographical locations.",
    ],
    [
        "fa-people-roof",
        "Community Impact",
        "UHCS works beyond institutions by promoting preventive healthcare and health awareness at the community level.",
    ],
    [
        "fa-briefcase-medical",
        "Career & Employment Support",
        "Our ecosystem aims to connect skill development with certification, employment, career progression, and international opportunities.",
    ],
];

const scrollLinks = [
    ["about", "About Us"],
    ["focus", "Focus Areas"],
    ["vision", "Vision"],
    ["mission", "Mission"],
    ["objectives", "Objectives"],
    ["programs", "Programs"],
    ["workforce", "1-Crore Mission"],
    ["why-us", "Why Choose UHCS"],
];

/* =========================================================
   MAIN COMPONENT
========================================================= */

function Aboutus() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    const closeMenu = () => setMenuOpen(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setModalOpen(true);
    };

    return (
        <div className="app">
           

            <main>
                {/* =================================================
                    ABOUT HERO
                ================================================= */}

                <section className="about-hero" id="home">
                    <div className="about-hero-glow about-hero-glow-one" />
                    <div className="about-hero-glow about-hero-glow-two" />

                    <div className="container about-hero-content">
                        <div className="about-hero-text">
                            <span className="about-label">
                                UNIVERSAL HEALTH COVERAGE STRIVES
                            </span>

                            <h1>
                                Quality Healthcare
                                <span> Skilled Professionals</span>
                                Affordable Health for All
                            </h1>

                            <div className="hero-actions">
                                <a href="#about" className="btn btn-primary">
                                    Discover UHCS
                                    <i className="fa-solid fa-arrow-right" />
                                </a>

                                <a href="#workforce" className="btn btn-secondary">
                                    1 Crore Mission
                                    <i className="fa-solid fa-users" />
                                </a>
                            </div>

                            <div className="hero-mini-stats">
                                <div>
                                    <strong>10</strong>
                                    <span>Focus Areas</span>
                                </div>

                                <div>
                                    <strong>10</strong>
                                    <span>Mission Priorities</span>
                                </div>

                                <div>
                                    <strong>1 Cr</strong>
                                    <span>Workforce Mission</span>
                                </div>
                            </div>
                        </div>

                        <div className="about-hero-image">
                            <div className="image-frame">
                                <img
                                    src={abouthealthcare}
                                    alt="Healthcare professionals"
                                />

                                <div className="hero-image-overlay" />

                                <div className="hero-floating-card">
                                    <div className="floating-icon">
                                        <i className="fa-solid fa-shield-heart" />
                                    </div>

                                    <div>
                                        <span>UHCS APPROACH</span>
                                        <strong>
                                            Quality • Skills • Access
                                        </strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* =================================================
                    ABOUT US
                ================================================= */}

                <section id="about" className="section white-section">
                    <div className="container">
                        <SectionHeading
                            eyebrow="01 • About Us"
                            title="Strengthening India's Healthcare Ecosystem"
                            text="Universal Health Coverage Strives (UHCS) is an India-registered initiative working toward strengthening healthcare quality, developing skilled healthcare professionals, supporting hospitals, and promoting affordable and accessible healthcare services for all."
                        />

                        <div className="about-content-grid">
                            <div className="about-copy">
                                <p>
                                    UHCS works with a vision inspired by Universal Health
                                    Coverage (UHC), WHO principles, JCI standards, and NABH
                                    quality frameworks to support continuous improvement in
                                    healthcare services and standards across India.
                                </p>

                                <p>
                                    Our approach brings together healthcare education,
                                    paramedical skill development, international
                                    certification, hospital quality improvement, healthcare
                                    technology, professional placement, social security,
                                    and community health awareness under one integrated
                                    platform.
                                </p>

                                <p>
                                    UHCS aims to create a stronger healthcare ecosystem where
                                    healthcare professionals are skilled, certified,
                                    employable, and continuously upgraded, while hospitals
                                    and healthcare institutions are supported in improving
                                    their quality, efficiency, compliance, and patient-care
                                    services.
                                </p>
                            </div>

                            <div className="about-highlight">
                                <div className="highlight-icon">
                                    <i className="fa-solid fa-heart-pulse" />
                                </div>

                                <h3>Our Goal</h3>

                                <p>
                                    Better Healthcare, Better Skills, Better Standards,
                                    and Better Access for All.
                                </p>
                            </div>
                        </div>

                        <div className="quote-box">
                            <i className="fa-solid fa-quote-right quote-bg" />

                            <p>
                                Our objective is to create meaningful opportunities for
                                healthcare and paramedical professionals while supporting
                                hospitals and healthcare institutions in improving their
                                services and quality systems.
                            </p>

                            <div className="quote-author">
                                <div>
                                    <i className="fa-solid fa-building" />
                                </div>

                                <span>
                                    <strong>Universal Health Coverage Strives</strong>
                                    <small>UHCS</small>
                                </span>
                            </div>
                        </div>

                        <div className="about-mission-text">
                            <p>
                                Through our proposed{" "}
                                <strong>
                                    “1 Crore Skilled Healthcare Professionals Mission”
                                </strong>
                                , we aim to contribute to the creation of a skilled and
                                future-ready healthcare workforce. We believe that every
                                trained professional can contribute to better patient care
                                and a stronger healthcare system.
                            </p>

                            <p>
                                UHCS also believes that healthcare quality should be
                                accessible and affordable. Therefore, we will continue to
                                work with healthcare institutions, professionals,
                                educational organizations, industry partners, and
                                communities to create sustainable solutions.
                            </p>

                            <p>
                                We invite healthcare professionals, hospitals, educational
                                institutions, industry organizations, government and
                                non-government stakeholders, and community partners to join
                                us in this journey. Together, we can build a healthier,
                                skilled, quality-driven and more inclusive India.
                            </p>
                        </div>
                    </div>
                </section>

                {/* =================================================
                    FOCUS AREAS
                ================================================= */}

                <section id="focus" className="section light-section">
                    <div className="container">
                        <SectionHeading
                            eyebrow="Our Focus"
                            title="The 10 Focus Areas of UHCS"
                            text="An integrated set of focus areas designed to strengthen healthcare quality, professional development, hospital services, and access to healthcare."
                        />

                        <div className="focus-grid">
                            {focusAreas.map(([num, title, icon]) => (
                                <div className="focus-card" key={num}>
                                    <div className="focus-top">
                                        <span className="focus-number">{num}</span>

                                        <div className="focus-icon">
                                            <i className={`fa-solid ${icon}`} />
                                        </div>
                                    </div>

                                    <h4>{title}</h4>

                                    <span className="focus-arrow">
                                        <i className="fa-solid fa-arrow-right" />
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* =================================================
                    VISION
                ================================================= */}

                <section id="vision" className="section dark-section vision-section">
                    <div className="container">
                        <div className="vision-layout">
                            <div className="vision-main">
                                <div className="eyebrow">
                                    <i className="fa-solid fa-eye" />
                                    02 • Our Vision
                                </div>

                                <h2>
                                    Building a High-Quality &amp; Globally Aligned
                                    Healthcare Ecosystem
                                </h2>

                                <p className="lead">
                                    To contribute toward building a high-quality, skilled,
                                    accessible, affordable, and globally aligned healthcare
                                    ecosystem in India, supporting the achievement of
                                    Universal Health Coverage.
                                </p>
                            </div>

                            <div className="vision-points">
                                {visionPoints.map((point, index) => (
                                    <CheckItem
                                        key={index}
                                        number={index + 1}
                                        text={point}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                {/* =================================================
                    MISSION
                ================================================= */}

                <section id="mission" className="section white-section">
                    <div className="container">
                        <SectionHeading
                            eyebrow="03 • Our Mission"
                            title="Creating a Sustainable Healthcare Ecosystem"
                            text="UHCS is committed to developing a sustainable healthcare ecosystem through education, skill development, quality improvement, certification, employment support, hospital strengthening, and community healthcare initiatives."
                        />

                        <div className="mission-grid">
                            {missions.map(([num, title]) => (
                                <div className="mission-card" key={num}>
                                    <span className="mission-number">{num}</span>

                                    <div className="mission-icon">
                                        <i className="fa-solid fa-check" />
                                    </div>

                                    <h4>{title}</h4>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* =================================================
                    OBJECTIVES
                ================================================= */}

                <section id="objectives" className="section light-section">
                    <div className="container">
                        <SectionHeading
                            eyebrow="04 • Our Core Objectives"
                            title="10 Strategic Objectives"
                            text="Our core objectives translate the UHCS vision and mission into practical areas of healthcare improvement and professional development."
                        />

                        <div className="objectives-grid">
                            {objectives.map(([num, title, text]) => (
                                <article className="objective-card" key={num}>
                                    <div className="objective-number">
                                        {num}
                                    </div>

                                    <div>
                                        <h4>{title}</h4>
                                        <p>{text}</p>
                                    </div>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                {/* =================================================
                    PROGRAMS
                ================================================= */}

                <section id="programs" className="section white-section">
                    <div className="container">
                        <SectionHeading
                            eyebrow="05 • Our Programs"
                            title="Integrated UHCS Programs"
                            text="Eight program areas bringing together healthcare professional development, hospital quality improvement, technology, community healthcare, and support services."
                        />

                        <div className="program-grid">
                            {programs.map(
                                ([
                                    letter,
                                    title,
                                    description,
                                    features,
                                    icon,
                                    note,
                                ]) => (
                                    <article
                                        className="program-card"
                                        key={letter}
                                    >
                                        <div className="program-card-top">
                                            <div className="program-letter">
                                                {letter}
                                            </div>

                                            <div className="program-icon">
                                                <i className={`fa-solid ${icon}`} />
                                            </div>
                                        </div>

                                        <h3>{title}</h3>

                                        <p>{description}</p>

                                        <ul className="program-list">
                                            {features.map((feature) => (
                                                <li key={feature}>
                                                    <i className="fa-solid fa-check" />
                                                    <span>{feature}</span>
                                                </li>
                                            ))}
                                        </ul>

                                        {note && (
                                            <div className="program-note">
                                                <i className="fa-solid fa-circle-info" />
                                                <span>{note}</span>
                                            </div>
                                        )}
                                    </article>
                                )
                            )}
                        </div>
                    </div>
                </section>

                {/* =================================================
                    WORKFORCE MISSION
                ================================================= */}

                <section
                    id="workforce"
                    className="section dark-section workforce"
                >
                    <div className="container">
                        <div className="workforce-intro">
                            <div>
                                <div className="eyebrow">
                                    <i className="fa-solid fa-users" />
                                    06 • National Scale Mission
                                </div>

                                <h2>
                                    “1 Crore Skilled Healthcare Professionals
                                    Mission”
                                </h2>

                                <h3>Building India's Future Healthcare Workforce</h3>

                                <p className="lead">
                                    UHCS proposes a long-term mission to contribute toward
                                    the development of 1 Crore skilled healthcare
                                    professionals through structured skill development,
                                    reskilling, certification, placement, and continuous
                                    professional development.
                                </p>
                            </div>

                            <div className="workforce-target-card">
                                <span>Mission Target</span>
                                <strong>1 Crore</strong>
                                <small>
                                    Skilled Healthcare Professionals
                                </small>
                            </div>
                        </div>

                        <div className="mission-objective-box">
                            <span>Mission Objective</span>

                            <p>
                                To create a large-scale ecosystem for developing skilled,
                                certified, employable, and future-ready healthcare
                                professionals across India.
                            </p>
                        </div>

                        <div className="subsection-heading dark-heading">
                            <span>Our Approach</span>
                            <h3>From Mobilization to Continuous Learning</h3>
                        </div>

                        <div className="workforce-steps">
                            {workforceSteps.map(
                                ([num, title, text, icon]) => (
                                    <div
                                        className="workforce-step"
                                        key={num}
                                    >
                                        <div className="step-icon">
                                            <i className={`fa-solid ${icon}`} />
                                        </div>

                                        <span>{num}</span>

                                        <h4>{title}</h4>

                                        <p>{text}</p>
                                    </div>
                                )
                            )}
                        </div>

                        <div className="impact-section">
                            <div className="subsection-heading dark-heading">
                                <span>Target Impact Areas</span>
                                <h3>Healthcare Workforce Priorities</h3>
                            </div>

                            <div className="impact-grid">
                                {targetImpactAreas.map((item) => (
                                    <div className="impact-item" key={item}>
                                        <i className="fa-solid fa-circle-check" />
                                        <span>{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="philosophy-box">
                            <span>Mission Philosophy</span>

                            <div className="philosophy-flow">
                                <strong>Skill</strong>
                                <i className="fa-solid fa-arrow-right" />
                                <strong>Certification</strong>
                                <i className="fa-solid fa-arrow-right" />
                                <strong>Employment</strong>
                                <i className="fa-solid fa-arrow-right" />
                                <strong>Career Growth</strong>
                                <i className="fa-solid fa-arrow-right" />
                                <strong>Better Healthcare</strong>
                            </div>

                            <p>
                                The mission will be implemented progressively through
                                partnerships with educational institutions, hospitals,
                                training organizations, healthcare professionals,
                                industry partners, certification bodies, and other
                                stakeholders.
                            </p>
                        </div>
                    </div>
                </section>

                {/* =================================================
                    WHY UHCS
                ================================================= */}

                <section id="why-us" className="section white-section">
                    <div className="container">
                        <SectionHeading
                            eyebrow="07 • Why Choose UHCS?"
                            title="An Integrated Healthcare Ecosystem"
                            text="UHCS combines professional skill development, healthcare quality, hospital support, certification, employment, technology, affordability, and community impact."
                        />

                        <div className="why-grid">
                            {whyChooseUs.map(([icon, title, text]) => (
                                <WhyCard
                                    key={title}
                                    icon={icon}
                                    title={title}
                                    text={text}
                                />
                            ))}
                        </div>
                    </div>
                </section>

                {/* =================================================
                    FINAL INVITATION
                ================================================= */}

                <section className="section invitation-section">
                    <div className="container">
                        <div className="invitation-card">
                            <div className="invitation-icon">
                                <i className="fa-solid fa-handshake-angle" />
                            </div>

                            <div>
                                <span className="section-label">
                                    Join The Journey
                                </span>

                                <h2>
                                    Together, We Can Build a Healthier India
                                </h2>

                                <p>
                                    We invite healthcare professionals, hospitals,
                                    educational institutions, industry organizations,
                                    government and non-government stakeholders, and
                                    community partners to join us in this journey.
                                </p>

                                <p>
                                    Together, we can build a healthier, skilled,
                                    quality-driven and more inclusive India.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* =================================================
                    CHAIRMAN
                ================================================= */}

                <section className="chairman-section">
                    <div className="container">
                        <div className="chairman-content">
                            <div className="chairman-icon">
                                <i className="fa-solid fa-user-tie" />
                            </div>

                            <div>
                                <span>With Best Wishes</span>

                                <h3>Chairman</h3>

                                <p>
                                    Universal Health Coverage Strives (UHCS)
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            {/* =====================================================
                FOOTER
            ===================================================== */}

            <footer className="site-footer">
                <div className="container footer-grid">
                    <div className="footer-brand">
                        <div className="brand">
                            <div className="brand-mark">
                                <i className="fa-solid fa-heart-pulse" />
                            </div>

                            <div className="brand-text">
                                <strong>UHCS</strong>
                                <span>
                                    Universal Health Coverage Strives
                                </span>
                            </div>
                        </div>

                        <p>
                            Quality Healthcare • Skilled Professionals •
                            Affordable Health for All
                        </p>
                    </div>

                    <FooterLinks
                        title="Explore"
                        links={scrollLinks.slice(0, 4)}
                    />

                    <FooterLinks
                        title="Programs"
                        links={[
                            ["#programs", "Skill Development"],
                            ["#programs", "International Certification"],
                            ["#programs", "Hospital Quality"],
                            ["#programs", "Community Healthcare"],
                        ]}
                    />

                    <FooterLinks
                        title="Mission"
                        links={[
                            ["#workforce", "1 Crore Mission"],
                            ["#objectives", "Core Objectives"],
                            ["#why-us", "Why Choose UHCS"],
                            ["#about", "About UHCS"],
                        ]}
                    />
                </div>

                <div className="footer-bottom">
                    <div className="container">
                        <p>
                            © {new Date().getFullYear()} Universal Health
                            Coverage Strives (UHCS). All rights reserved.
                        </p>
                    </div>
                </div>
            </footer>

            {/* =====================================================
                MODAL
            ===================================================== */}

            {modalOpen && (
                <div
                    className="modal-overlay"
                    onClick={() => setModalOpen(false)}
                >
                    <div
                        className="modal glass-dark"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="modal-icon">
                            <i className="fa-solid fa-check" />
                        </div>

                        <h3>Successfully Submitted!</h3>

                        <p>
                            Thank you for registering with UHCS. Our secretariat
                            will review your details and contact you shortly.
                        </p>

                        <button
                            className="btn btn-primary"
                            onClick={() => setModalOpen(false)}
                        >
                            Close Window
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

/* =========================================================
   COMPONENTS
========================================================= */

function SectionHeading({ eyebrow, title, text }) {
    return (
        <div className="section-heading">
            <span>{eyebrow}</span>
            <h2>{title}</h2>
            <p>{text}</p>
        </div>
    );
}

function CheckItem({ text, number }) {
    return (
        <div className="check-item">
            <span>
                {number ? (
                    number
                ) : (
                    <i className="fa-solid fa-check" />
                )}
            </span>

            <p>{text}</p>
        </div>
    );
}

function WhyCard({ icon, title, text }) {
    return (
        <article className="why-card">
            <div className="why-icon">
                <i className={`fa-solid ${icon}`} />
            </div>

            <h4>{title}</h4>

            <p>{text}</p>
        </article>
    );
}

function FooterLinks({ title, links }) {
    return (
        <div className="footer-links">
            <h4>{title}</h4>

            <ul>
                {links.map(([href, label]) => (
                    <li key={`${href}-${label}`}>
                        <a href={href}>{label}</a>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default Aboutus;